export const calculateSum = (array: Array<string>) =>
  array.reduce((prevSum, value) => prevSum + +(value || 0), 0);
